(function($) {





  jQuery( ".header-links .icons" ).append( '<i class="fa fa-user"></i>' );
  jQuery(".header-links .cusstom-link").hide();
  jQuery(".header-links .icons i").addClass("accordion-show");
  jQuery(".header-links .icons i").click(function(){
    if(jQuery(this).parent().next().is(":visible")){
      jQuery(this).addClass("accordion-show");
    }else{
      jQuery(this).removeClass("accordion-show");
    }
    jQuery(this).parent().next().toggle(400);
  });
  jQuery('#search-top .icon-search').click(function(){

    jQuery('#search-top .search-form').fadeIn('300');
    jQuery('#search-top .search-form .inputbox').focus().css("color","#000");
  });
  jQuery('#search-top .search-close').click(function(){
    jQuery('#search-top .search-form').fadeOut('300');
  });
  jQuery('#currencies-top .dropdown-currency').hide();
  jQuery('#currencies-top').hover(
    function () {
      jQuery(this).addClass('active').find('.dropdown-currency').stop().delay(200).slideDown();
    },
    function () {
      jQuery(this).removeClass('active').find('.dropdown-currency').stop().delay(200).slideUp();
    }
  );

  var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
    jQuery(mainImageDomEl).attr('src', newImageSrc);

    if ($(window).width() > 782) {jQuery(mainImageDomEl).parent().trigger('zoom.destroy').zoom( { url: newImageSrc.replace('_master', '') } );}

    $(mainImageDomEl).parents('a').attr('href', newImageSrc);

  };

  $(function () {
    $('[data-toggle="tooltip"]').tooltip()
  })


  $(document).ready(function() {
    $("#zt_list_product ul").resize( function() {
      var element = $(this),
          width = element.innerWidth() / 4;
      // This shows 1 item at a time.
      // Divide `width` to the number of items you want to display,
      // eg. `width = width / 3` to display 3 items at a time.
      console.log("Carousel W = "+width);
      element.jcarousel('items').css('width', width + 'px');
    });
    $("#zt_list_product ul").jcarousel({
      horizontal: true
    }).css("visibility", "visible");
    $(".product-img-box").addClass("has-jcarousel");
    $(".thumbs").css("visibility", "visible")
  });


  jQuery(window).scroll(function() {
    if (jQuery(this).scrollTop() > 200) {
      jQuery("#back-top").fadeIn()
    } else {
      jQuery("#back-top").fadeOut()
    }
  });
  jQuery( ".footer-top h3.module-title" ).append( '<i class="arrow_carrot-down"></i>' );
  jQuery(".footer-top .content").hide();
  jQuery(".footer-top h3.module-title i").addClass("accordion-show");
  jQuery(".footer-top h3.module-title i").click(function(){
    if(jQuery(this).parent().next().is(":visible")){
      jQuery(this).addClass("accordion-show");
    }else{
      jQuery(this).removeClass("accordion-show");
    }
    jQuery(this).parent().next().toggle(400);
  });



  if (navigator.userAgent.indexOf('MSIE') != -1)
    var detectIEregexp = /MSIE (\d+\.\d+);/
    else 
      var detectIEregexp = /Trident.*rv[ :]*(\d+\.\d+)/ 

      if (detectIEregexp.test(navigator.userAgent)){
        var ieversion=new Number(RegExp.$1)
        if (ieversion < 10){
          jQuery('#loading').fadeOut('slow');
        }

      }

  jQuery(document).ready(function($){
    $('.up-qty').click(function(){
      quantity =$('#quantity').val();
      $('#quantity').val(parseInt(quantity) + 1);
    });
    $('.down-qty').click(function(){
      quantity =$('#quantity').val();
      if(quantity > 1)
        $('#quantity').val(parseInt(quantity) - 1);
    });
    $('#zoom-full-img').click(function(){
      $('#product-featured-image').trigger('click');
    });
    jQuery("a.zoom").fancybox({
      padding:0,
      'titleShow': false,
      overlayColor: '#000000',
      overlayOpacity: 0.2
    });

    /* Update main product image when a thumbnail is clicked. */
    /*==========================*/
    jQuery('#product .thumbs a').on('click', function(e) {
      e.preventDefault();
      switchImage(jQuery(this).attr('href'), null, jQuery('.featured img')[0]);
    } );


    /* Initialize zoom on main product image */
    var mainProductImage = jQuery('.featured img');
    if (mainProductImage.size()) {
      if (jQuery(window).width() > 782) {
        var zoomedSrc = $('.featured img').attr('src').replace('_master', '');
        $('.featured img')
        .wrap('<span style="display:inline-block; max-width: 100%;"></span>')
        .css('display', 'block')
        .parent()
        .zoom( { url: zoomedSrc } );
      }
    }
    $('.content-slider h4').hover(function(){
      $(this).parent().prev().addClass('hover');
    },function(){
      $(this).parent().prev().removeClass('hover');
    });


    $('.trigger-review').click(function(){
      $('.tab-content .spr-form').hide();
      $('.spr-summary-actions a').trigger('click');
      var toTop = $( $('.trigger-review').attr('href') ).offset().top;
      toTop = parseInt(toTop) -parseInt(150);
      jQuery('html, body').animate({
        scrollTop: toTop
      }, 1000,function(){
        $('.tab-review').trigger('click');

      });



    });

  });




  jQuery('.sca-qv-button-wrap').hide();

  jQuery('.slide-des').hide();
  jQuery(window).load(function() {



    jQuery('.slide-des').fadeIn('slow').height(jQuery('.flexslider .slides').height());
    jQuery('.sca-qv-button-wrap').show('fast');


    jQuery('.overlay_border').hover(function(){
      jQuery(this).parent().toggleClass('hover');
    });

    $('#loading').fadeOut('slow');
  });	
  jQuery(window).resize(function() {
    jQuery('.slide-des').fadeIn().height(jQuery('.flexslider .slides').height());

  });


  jQuery("img").lazyload({
    effect : "fadeIn"
  });





  /* placholder on IE8 */


  (function ($) {
    $.support.placeholder = ('placeholder' in document.createElement('input'));
  })(jQuery);


  //fix for IE7 and IE8
  $(function () {
    if (!$.support.placeholder) {
      $("[placeholder]").focus(function () {
        if ($(this).val() == $(this).attr("placeholder")) $(this).val("");
      }).blur(function () {
        if ($(this).val() == "") $(this).val($(this).attr("placeholder"));
      }).blur();

      $("[placeholder]").parents("form").submit(function () {
        $(this).find('[placeholder]').each(function() {
          if ($(this).val() == $(this).attr("placeholder")) {
            $(this).val("");
          }
        });
      });
    }
  });
})(jQuery);





